import React, { useState, useEffect } from "react";
import CustomFilters from "../../../../core/custom-filters";
import { Box, TextField } from "@mui/material";
import {
  HTTP_METHODS,
  invokeApi,
  plainApi,
} from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import SiAutocomplete from "../../../../core/si-autocomplete";
import SiTextField from "../../../../core/si-textfield";
import { PAGE_LIMIT } from "../../../../utils";

const InternalCutInFilters = ({ loadData }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [oemList, setOemList] = useState([]);
  const [endDate, setEndDate] = useState("");
  let oemTimeout = null;

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else {
          if (key === "cutInDate") {
            payload["startDate"] = filters[key];
            if (endDate) {
              payload["endDate"] = endDate;
            }
          } else {
            payload[key] = filters[key];
          }
        }
      }

      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: 1,
      });
    } else {
      loadData({ sortBy: "-createdAt", limit: PAGE_LIMIT, page: 1 });
    }
  };

  const filterTypes = [
    { label: "Filter by Plant", value: "plant" },
    { label: "Filter by List Number", value: "listNo" },
    { label: "Filter by Cut In Number", value: "engineCutInNumber" },
    { label: "Filter by Engine Model", value: "engineModel" },
    { label: "Filter by Cut In Date", value: "cutInDate" },
    { label: "Filter by OEM", value: "oem" },
  ];

  const renderFilterInput = () => {
    switch (filterType) {
      case "engineModel":
        return (
          <SiTextField
            placeholder="Engine Model"
            name="engineModel"
            onChange={handleFilterValueChange}
          />
        );
      case "plant":
        return (
          <SiTextField
            placeholder="Plant"
            name="plant"
            onChange={handleFilterValueChange}
          />
        );
      case "engineCutInNumber":
        return (
          <SiTextField
            placeholder="Cut In Number"
            name="engineCutInNumber"
            onChange={handleFilterValueChange}
          />
        );
      case "cutInDate":
        return (
          <Box sx={{ display: "flex", gap: "20px" }}>
            <div>
              <p style={{ margin: "0px", fontWeight: 500 }}>Start Date</p>
              <SiTextField
                placeholder="Start Date"
                name="startDate"
                type="date"
                onChange={handleFilterValueChange}
                sx={{ mt: 1 }}
              />
            </div>
            <div>
              <p style={{ margin: "0px", fontWeight: 500 }}>End Date</p>
              <SiTextField
                placeholder="End Date"
                name="endDate"
                type="date"
                onChange={(e) => setEndDate(e.target.value)}
                sx={{ mt: 1 }}
              />
            </div>
          </Box>
        );
      case "oem":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={oemList}
            placeholder="Search OEM"
          />
        );
      case "listNo":
        return (
          <SiTextField
            placeholder="List Number"
            name="listNo"
            onChange={handleFilterValueChange}
          />
        );

      default:
        return null;
    }
  };
  const getOemList = (filters) => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null, {
      ...filters,
    })
      .then((response) => {
        if (response) {
          const result = response.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setOemList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const handleRegexSearch = (newInputValue) => {
    clearTimeout(oemTimeout);
    if (newInputValue) {
      oemTimeout = setTimeout(() => getOemList(newInputValue), 300);
    }
  };
  useEffect(() => {
    if (filterType === "oem") {
      getOemList();
    }
  }, [filterType]);
  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default InternalCutInFilters;
